import React from 'react'
import Link from './link'
import './lawSection.css'

const LawSection = ({ lang }) => {

  return (
  <div>
    <div className="law-section">
      <div className="links">
        <Link className="footer-link" to={`#`}>
          {'About Xiaomi'}
        </Link>
        <Link className="footer-link" to={`https://www.mi.com/global/about/mediakit/`}>
          {'Press & Media'}
        </Link>  
        <Link className="footer-link" to={`https://blog.mi.com/en/`}>
          {'Xiaomi Blog'}
        </Link>    
        <Link className="footer-link" to={`https://privacy.mi.com/xiaomicloud/`}>
          {'InteGrity & Compliance'}
        </Link>
        <Link className="footer-link" to={`https://company.mi.com/en-us/ir/indexContent/`}>
          {'Investor Relations'}
        </Link>
        <Link className="footer-link" to={`https://trust.mi.com/en`}>
          {'Trust Center'}
        </Link>
      </div>
      <div className="links">
        <Link className="footer-link" to={`https://en.miui.com/`}>
          {'MIUI'}
        </Link>
        <Link className="footer-link" to={`https://www.mi.com/global`}>
          {'Mi Store'}
        </Link>
        <Link className="footer-link" to={`https://c.mi.com/global`}>
          {'Mi Community'}
        </Link>
        <Link className="footer-link" to={`https://www.mi.com/global/about/agreement`}>
          {'User Agreement'}
        </Link>
        <Link className="footer-link" to={`https://privacy.mi.com/all/en`}>
          {'Privacy Policy'}
        </Link>
      </div>
    </div>
    <div className="bottom">
      <div className="reserve">{'Copyright © 2010 - 2022 Xiaomi. All Rights Reserved.'}</div>
    </div>
  </div>
  )
}

export default LawSection
